import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppContext } from '../../contexts/AppContext';
import GamePage from '../../pages/GamePage';
import HomePage from '../../pages/HomePage';
import RegisterPage from '../../pages/RegisterPage'
import LoginPage from '../../pages/LoginPage';
import ForgetPassword from '../../pages/ForgetPassword';

import ConsentPage from '../../pages/ConsentPage';

import SondagePage from '../../pages/SondagePage';

import ProtectedRoute from './PrivateRoute';
import { useContext } from "react";
import AdminPage from '../../pages/AdminPage';


const Router = () => {
  const { jwtToken, role, hasReadConsent,survey } = useContext(AppContext);

  return (
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/register' element={<RegisterPage />} />
          <Route path='/login' element={<LoginPage />} />
          <Route path='/forgetpassword' element={<ForgetPassword />} />
          <Route path='/consent' element={<ProtectedRoute outlet={<ConsentPage />} isLoggedIn={jwtToken !== null} defaultPath={"/"} />}/>
          <Route path='/sondage' element={<ProtectedRoute outlet={<SondagePage />} isLoggedIn={jwtToken !== null} defaultPath={"/"} />} />
          <Route path='/game' element={<ProtectedRoute defaultPath={"/"} outlet={<ProtectedRoute defaultPath={"/consent"} outlet={<ProtectedRoute defaultPath={"/sondage"} outlet={<GamePage />} isLoggedIn={survey!=undefined} />} isLoggedIn={hasReadConsent} />} isLoggedIn={jwtToken !== null} />} />
          <Route path='/admin' element={<ProtectedRoute outlet={<AdminPage />} isAdmin={role === "ADMIN"} isLoggedIn={jwtToken !== null} defaultPath={"/"} />} />
        </Routes>
      </BrowserRouter>
  );
}


export default Router;
